/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Misfit_5Inputs */

const en_pc_alt_misfit_5 = /** @type {(inputs: Pc_Alt_Misfit_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phones and tablets, which have no PdfCraft app, and full XFA forms, which are not supported yet.`)
};

const zh_pc_alt_misfit_5 = /** @type {(inputs: Pc_Alt_Misfit_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手机和平板（PdfCraft 没有移动应用），以及完整的 XFA 表单（暂不支持）。`)
};

/**
* | output |
* | --- |
* | "Phones and tablets, which have no PdfCraft app, and full XFA forms, which are not supported yet." |
*
* @param {Pc_Alt_Misfit_5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_misfit_5 = /** @type {((inputs?: Pc_Alt_Misfit_5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Misfit_5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_misfit_5(inputs)
	return zh_pc_alt_misfit_5(inputs)
});
export { pc_alt_misfit_5 as "pc.alt.misfit.5" }